import React from 'react';
import { AlertTriangle, CheckCircle2, Info, XCircle } from 'lucide-react';
import { cn } from './cn';
import type { Tone } from './Badge';

/**
 * Alert — mensagem contextual dentro da página (não é toast).
 * Ícone à esquerda, título em peso 550 e corpo secundário.
 */
const TONE_STYLE: Record<Tone, { box: string; icon: string }> = {
  neutral: { box: 'border-line bg-sunken', icon: 'text-fg-2' },
  primary: { box: 'border-primary-line bg-primary-soft', icon: 'text-primary' },
  success: { box: 'border-success-line bg-success-soft', icon: 'text-success' },
  warning: { box: 'border-warning-line bg-warning-soft', icon: 'text-warning' },
  danger: { box: 'border-danger-line bg-danger-soft', icon: 'text-danger' },
  info: { box: 'border-info-line bg-info-soft', icon: 'text-info' },
};

const TONE_ICON: Record<Tone, React.ReactNode> = {
  neutral: <Info size={17} />,
  primary: <Info size={17} />,
  success: <CheckCircle2 size={17} />,
  warning: <AlertTriangle size={17} />,
  danger: <XCircle size={17} />,
  info: <Info size={17} />,
};

export function Alert({
  tone = 'neutral',
  title,
  icon,
  action,
  className,
  children,
}: {
  tone?: Tone;
  title?: React.ReactNode;
  icon?: React.ReactNode;
  action?: React.ReactNode;
  className?: string;
  children?: React.ReactNode;
}) {
  const style = TONE_STYLE[tone];
  return (
    <div className={cn('flex gap-3 rounded-[10px] border p-[13px_14px]', style.box, className)}>
      <span className={cn('mt-px flex-none', style.icon)}>{icon ?? TONE_ICON[tone]}</span>
      <div className="min-w-0 flex-1">
        {title && <p className="text-[13.5px] font-semibold text-fg">{title}</p>}
        {children && <p className={cn('text-[13px] text-fg-2', title && 'mt-0.5')}>{children}</p>}
      </div>
      {action && <div className="flex-none self-center">{action}</div>}
    </div>
  );
}
